export type QuoteColumnType = 'description' | 'response_quantity' | 'response_value' | 'response_number' | 'response_text' | 'unit_of_measurement' | 'total';


/**
 * Mode determines how quote table components render:
 * - "edit": Procurer creation mode — full column/row CRUD, structural editing
 * - "respond": Bidder submission mode — suppliers fill in values
 * - "view": Read-only mode — no editing allowed
 */
export type QuoteTableMode = 'edit' | 'respond' | 'view';

export interface QuoteTableColumn {
    id: number;
    columnType: QuoteColumnType;
    label: string;
    sortOrder: number;
    isDefault?: boolean;
    isSupplierEditable?: boolean;
}

export interface QuoteTableRow {
    itemId: number;
    name: string;
    unitLabel?: string;
    quantity: number;
    rate: number;
    createdByType?: 'client' | 'supplier';
    unitId?: number;
    columnValues?: Record<number, string>;
    quantityCategories?: Record<number, { quantity: number; rate: number }>;
}

export interface SupplierRow {
    description: string;
    localId: string;
    quantity: string;
    rate: string;
    savedId?: number;
    unitId: number | null;
    columnValues?: Record<number, string>;
}

export interface ColumnHeader {
    columnId?: number;
    columnType?: QuoteColumnType;
    isDefault?: boolean;
    isFirstOfGroup?: boolean;
    key: string;
    label: string;
    width: string;
}

export const CELL_BORDER = "border border-[#EAECF0]";
export const COLUMN_STYLE = "pl-2 font-roboto text-sm bg-gray-50";
